import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Login from 'app/components/auth/SignIn/SignIn';
import { SignUpWithEligibility } from 'app/components/auth/SignUp/SignUpWithEligibility/';
import ForgotPassword from 'app/components/auth/ForgotPassword/ForgotPassword';
import ResetPassword from 'app/components/auth/ResetPassword/ResetPassword';
import { VerifyEmail } from 'app/components/auth/VerifyEmail';
import { EcommTestRegistration } from 'app/components/auth/EcommTest/EcommTestRegistration';
import { useSynapse } from 'app/lib/synaptik';

const RegistrationExperiment = () => {
  const requestedDrug = useSynapse(({ services }) => services.getRequestedDrug());

  const isValidRequestedDrug = !!(
    requestedDrug &&
    requestedDrug.displayName &&
    requestedDrug.dose &&
    requestedDrug.quantity &&
    requestedDrug.cost &&
    requestedDrug.rxcui
  );

  return (
    <Route exact path="/register" component={isValidRequestedDrug ? EcommTestRegistration : SignUpWithEligibility} />
  );
};

const Auth = () => (
  <Switch>
    <Route exact path="/login" component={Login} />
    <Route exact path="/forgot-password" component={ForgotPassword} />
    <Route exact path="/reset-password" component={ResetPassword} />
    <Route exact path="/verify-email/:token" component={VerifyEmail} />
    <RegistrationExperiment />
  </Switch>
);

export default Auth;
